import styled from 'styled-components';

export default styled.div`
	margin-bottom: 15px;
	background: #222;
	border-radius: 10px;
	padding: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #fff;
	position: relative;
	overflow: hidden;
	.info {
		.title,
		.tags {
			display: flex;
		}
		.title {
			font-weight: bold;
		}
		.tags {
			margin-top: 5px;
			font-size: 12px;
		}
	}
	.details {
		.price {
			font-weight: bold;
			.currency {
				font-weight: normal;
				font-size: 12px;
				opacity: 0.7;
			}
		}
	}
	.delete-button {
		position: absolute;
		left: 0;
		width: 40%;
		border: 0;
		border-radius: 3px;
		background: #f54949;
		display: flex;
		align-items: center;
		justify-content: center;
		top: 0;
		bottom: 0;
		z-index: 10;
	}
`;
